import { UsageCostsPage } from '@/features/usage-costs/UsageCostsPage';

export default UsageCostsPage;
